import { HL7HttpHeader } from '@synanetics/constants';
import { type IncomingMessage, type ServerResponse } from 'http';

type NextFunction = (error?: any) => void;
interface Trace {
  version?: string;
  id?: string;
  parentSpan?: string;
  flags?: string;
  span?: string;
}

export function parseTraceContext(req: IncomingMessage): Trace {
  const trace: Trace = {};
  if (!req || !req.headers) {
    return trace;
  }
  if (req.headers.traceparent) {
    const traceparent = (req.headers.traceparent as string).toLowerCase();

    if (traceparent.match(/^([0-9a-f]{2})-([0-9a-f]{32})-([0-9a-f]{16})-([0-9a-f]{2})$/)) {
      [trace.version, trace.id, trace.parentSpan, trace.flags] = traceparent.split('-');
    }
  } else {
    if (req.headers['x-b3-traceid']) {
      trace.id = (req.headers['x-b3-traceid'] as string).toLowerCase();
    }
    if (req.headers['x-b3-spanid']) {
      trace.span = (req.headers['x-b3-spanid'] as string).toLowerCase();
    }
    if (req.headers['x-b3-parentspanid']) {
      trace.parentSpan = (req.headers['x-b3-parentspanid'] as string).toLowerCase();
    }
  }
  return trace;
}

export const sessionTracking = () => (
  req: any,
  _res: ServerResponse,
  next: NextFunction,
): any => {
  const trace: Trace = parseTraceContext(req);
  if (trace.id) {
    req.$ctx.requestID = trace.id;
  }
  if (trace.span) {
    req.$ctx.id = trace.span;
  }
  if (trace.parentSpan) {
    req.$ctx.parentID = trace.parentSpan;
  }
  next();
};

export const ifNoneExistsHeaderTransform = () => (
  req: IncomingMessage,
  _res: ServerResponse,
  next: NextFunction,
): any => {
  if ('if-none-exists' in req.headers && !(HL7HttpHeader.IF_NONE_EXIST in req.headers)) {
    req.headers[HL7HttpHeader.IF_NONE_EXIST] = req.headers['if-none-exists'];
  }
  next();
};
